import jsPDF from 'jspdf'
import XLSX from 'xlsx'
import html2canvas from 'html2canvas'
import 'jspdf-autotable'

export const generatePDF = async (table, heading , subHeader) => {
  const input = document.querySelector(table)
  if (input) {
    // Wait for the content to be fully rendered
    await new Promise(resolve => setTimeout(resolve, 1000))

    // Capture the table as an image
    const canvas = await html2canvas(input, { scale: 2, height: 1000 })
    const imgData = canvas.toDataURL('image/png')
    // input.style.height = '1000px' 

    // Initialize jsPDF with 'p' for portrait, 'mm' for millimeters, 'a4' for A4 size
    const pdf = new jsPDF('p', 'mm', 'a4')

    // Define margins (in millimeters)
    const marginLeft = 10
    const marginTop = 15

    // Add title to the PDF
    pdf.setFontSize(16)
    pdf.text(heading, marginLeft, marginTop)
    
    if (subHeader) {
      pdf.setFontSize(12) 
      pdf.text(subHeader, marginLeft, marginTop + 10) 
    }

    // Get PDF dimensions
    const pdfWidth = pdf.internal.pageSize.getWidth()
    const pdfHeight = pdf.internal.pageSize.getHeight()

    // Calculate dimensions of the image to be added
    const imgProps = pdf.getImageProperties(imgData)
    const imgWidth = pdfWidth - 2 * marginLeft
    const imgHeight = (imgProps.height * imgWidth) / imgProps.width

    // Check if the image height is larger than the page height and scale accordingly
    let finalImgHeight = imgHeight
    let finalMarginTop = marginTop + 10 
    if (subHeader) {
      finalMarginTop += 5
    }
    if (imgHeight > (pdfHeight - 2 * marginTop)) {
      finalImgHeight = pdfHeight - 2 * marginTop
      finalMarginTop = marginTop
    }

    // Add the image to PDF with margins
    pdf.addImage(imgData, 'PNG', marginLeft, finalMarginTop, imgWidth, finalImgHeight)

    // Generate PDF as blob
    const pdfBlob = pdf.output('blob')
    const pdfBlobUrl = URL.createObjectURL(pdfBlob)

    return pdfBlobUrl
  }
}

// Function to generate PDF from your structure
export const generatePDF1 = (tableData, structure, header, subHeader) => {
  const doc = new jsPDF()

  doc.setFontSize(18)
  doc.text(header, 14, 20)

  if(subHeader) {
    doc.setFontSize(14)
    doc.text(subHeader, 14, 30)
  }

  // Extract headers from the structure
  const columns = structure.headers.map(header => {
    return typeof header.value === 'function' ? header.value() : header.value
  })

  // Extract rows from the structure's dataKeys and apply formatting
  const rows = tableData.map(data => {
    return structure.dataKeys.map(key => {
      const rowFormat = structure.rowFormat[key]
      const cellValue = data[key]

      // Apply formatting if exists in rowFormat
      return rowFormat && rowFormat.format
        ? rowFormat.format(cellValue)
        : cellValue
    })
  })

  // Generate PDF table using autoTable plugin
  doc.autoTable({
    head: [columns],
    body: rows,
    startY: subHeader ? 35 : 28, 
    theme: 'grid',
    headStyles: {
      lineWidth: 0.1 
    },
    columnStyles: {
      2: { minCellWidth: 15 },
      3: { minCellWidth: 17 },
      6: { minCellWidth: 17 }
    }
  })

  const pdfBlob = doc.output('blob')
  const pdfBlobUrl = URL.createObjectURL(pdfBlob)
  
  return pdfBlobUrl
}

// logic for generating and downloading Report excel sheet 
export const generateExcel = (table,header,body,custom) => {
  const selectedTable = document.querySelector(table) // Corrected to querySelector
  if (selectedTable) {
    const wsData = []

    // Get table headers
    const headers = selectedTable.querySelectorAll(header)
    if (headers.length > 0) {
      const headerData = Array.from(headers).map(header => header.innerText)
      wsData.push(headerData)
    }

    // Get table rows
    const rows = selectedTable.querySelectorAll(body)
    if (rows.length > 0) {
      rows.forEach(row => {
        const rowData = Array.from(row.children).map(cell => cell.innerText)
        if(custom){
          if(rowData.length === 15){
            rowData.unshift(' ')
          }
        }
        wsData.push(rowData)
      })
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new()
    const ws = XLSX.utils.aoa_to_sheet(wsData)

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    // Generate Excel file and download
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })
    const buf = new ArrayBuffer(wbout.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i < wbout.length; ++i) view[i] = wbout.charCodeAt(i) & 0xFF
    const excelBlob = new Blob([buf], { type: 'application/octet-stream' })
    const excelBlobUrl = URL.createObjectURL(excelBlob)

    // Trigger the download
    const link = document.createElement('a')
    link.href = excelBlobUrl
    link.download = 'report.xlsx'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } else {
    console.error('Table element not found')
  }
}